<div class="flex w-full flex-col gap-1">
  <div class="flex items-center gap-2">
    <div
      class="border-default flex-none overflow-hidden rounded-sm border"
      [class.border-red-500]="hasError()">
      <svg
        [attr.width]="thumbWidth"
        [attr.height]="thumbHeight"
        [attr.viewBox]="'0 0 ' + thumbWidth + ' ' + thumbHeight"
        class="block bg-zinc-100 dark:bg-zinc-800">
        @if (thumbnailPath()) {
          <path
            [attr.d]="thumbnailPath()"
            class="fill-accent-main/20 stroke-accent-main"
            stroke-width="1.5" />
        }
      </svg>
    </div>

    @if (isEmpty()) {
      <span class="text-text-tertiary text-xs">
        {{ 'features.geographic_area.no_geometry' | translate }}
      </span>
    } @else {
      <span
        class="border-default bg-elevated text-text-primary inline-flex h-[30px] items-center rounded-sm border px-2.5 font-mono text-xs">
        {{
          'features.geographic_area.summary'
            | translate: { vertices: vertexCount(), area: areaKm2() }
        }}
      </span>
    }

    <button
      type="button"
      class="btn-secondary h-[30px] px-3 text-xs"
      [disabled]="isDisabled() || isReadOnly()"
      (click)="onEditOnMap()">
      <i [class]="ICONS.pencil" class="mr-1.5"></i>
      {{ 'common.edit_on_map' | translate }}
    </button>

    @if (!isEmpty()) {
      <button
        type="button"
        class="btn-transparent h-[30px] px-2 text-xs"
        [disabled]="isDisabled()"
        (click)="onClear()">
        <i [class]="ICONS.eraser" class="mr-1.5"></i>
        {{ 'common.clear' | translate }}
      </button>
    }
  </div>

  @if (isReadOnly()) {
    <p class="text-text-secondary flex items-center gap-1.5 text-xs">
      <i [class]="ICONS.warning" class="text-orange-500"></i>
      {{ 'features.geographic_area.has_holes' | translate }}
    </p>
  }

  <!--
    A bad boundary is reported through the form-builder's field-error channel, like every
    other field's, so it is not repeated here. The red border above still marks it before
    the field has been touched, and the on-map panel names the problem while drawing.
  -->

  @if (!isEmpty() && totalSites() > 0) {
    <p class="text-text-tertiary text-xs">
      @if (totalSites() > loadedSites()) {
        {{
          'features.geographic_area.covered_sites_capped'
            | translate
              : { covered: coveredSites(), loaded: loadedSites(), total: totalSites() }
        }}
      } @else {
        {{
          'features.geographic_area.covered_sites'
            | translate: { covered: coveredSites(), total: totalSites() }
        }}
      }
    </p>
  }
</div>
